// Native Web Notifications API helpers for desktop/browser alerts.

export function desktopSupported() {
  return typeof window !== "undefined" && "Notification" in window;
}

export function desktopPermission() {
  return desktopSupported() ? Notification.permission : "unsupported";
}

export async function requestDesktopPermission() {
  if (!desktopSupported()) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  try {
    return await Notification.requestPermission();
  } catch (e) {
    return Notification.permission;
  }
}

async function swRegistration() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return (await navigator.serviceWorker.getRegistration()) || null;
  } catch (e) { return null; }
}

// Prefer the service worker (reliable in Edge/Chrome/Android), fall back to the page Notification constructor.
export async function showDesktop({ title, body, tag, url, onClick }) {
  if (!desktopSupported() || Notification.permission !== "granted") return false;
  const opts = { body: body || "", tag: tag || undefined, icon: "/icon-192.png", badge: "/icon-192.png", renotify: !!tag, data: { url: url || "/" } };
  const reg = await swRegistration();
  if (reg?.showNotification) {
    try { await reg.showNotification(title, opts); return true; } catch (e) { /* fall through */ }
  }
  try {
    const n = new Notification(title, opts);
    n.onclick = () => {
      try { window.focus(); } catch (e) { /* ignore */ }
      if (onClick) onClick();
      n.close();
    };
    return true;
  } catch (e) { return false; }
}
